<div class="cd-modal-backdrop" (click)="close.emit()">
  <div class="cd-modal-wrap cd-modal-wrap--md" (click)="$event.stopPropagation()">
    <!-- Modal Head -->
    <div class="modal-head">
      <div>
        <div class="eyebrow">STUDENT DIRECTORY</div>
        <h2>Add Student</h2>
        <p class="modal-subtitle">Add students manually or upload a CSV file</p>
      </div>
      <button type="button" class="icon-button" (click)="close.emit()" aria-label="Close modal">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>

    <!-- Tab Switcher -->
    <div class="tab-pill-bar">
      <button type="button" class="tab-pill-btn" [class.active]="activeTab === 'manual'" (click)="switchTab('manual')">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>
        Manual Entry
      </button>
      <button type="button" class="tab-pill-btn" [class.active]="activeTab === 'csv'" (click)="switchTab('csv')">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
        Upload CSV
      </button>
    </div>

    <!-- ============== MANUAL ENTRY ============== -->
    <form *ngIf="activeTab === 'manual'" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-grid">
        <div class="field-item">
          <label class="field-lbl">First Name<span class="required-star">*</span></label>
          <input type="text" class="standard-input" formControlName="first_name" placeholder="Enter first name" />
          <small class="text-danger" *ngIf="form.get('first_name')?.touched && form.get('first_name')?.hasError('required')">
            First name is required
          </small>
        </div>

        <div class="field-item">
          <label class="field-lbl">Last Name<span class="required-star">*</span></label>
          <input type="text" class="standard-input" formControlName="last_name" placeholder="Enter last name" />
          <small class="text-danger" *ngIf="form.get('last_name')?.touched && form.get('last_name')?.hasError('required')">
            Last name is required
          </small>
        </div>

        <div class="field-item">
          <label class="field-lbl">Email<span class="required-star">*</span></label>
          <input type="email" class="standard-input" formControlName="email" placeholder="Enter email address" />
          <small class="text-danger" *ngIf="form.get('email')?.touched && form.get('email')?.hasError('required')">
            Email is required
          </small>
          <small class="text-danger" *ngIf="form.get('email')?.touched && form.get('email')?.hasError('email')">
            Enter a valid email address
          </small>
        </div>

        <div class="field-item">
          <label class="field-lbl">Mobile Number<span class="required-star">*</span></label>
          <input type="tel" class="standard-input" formControlName="phone_number" placeholder="10-digit mobile number" maxlength="10" />
          <small class="text-danger" *ngIf="form.get('phone_number')?.touched && form.get('phone_number')?.hasError('required')">
            Mobile number is required
          </small>
          <small class="text-danger" *ngIf="form.get('phone_number')?.touched && form.get('phone_number')?.invalid && !form.get('phone_number')?.hasError('required')">
            Enter a valid 10-digit mobile number
          </small>
        </div>

        <div class="field-item full-width">
          <label class="field-lbl">College / University Name</label>
          <input type="text" class="standard-input" [value]="collegeName || '—'" readonly />
        </div>

        <div class="field-item">
          <label class="field-lbl">Course / Degree<span class="required-star">*</span></label>
          <select class="standard-input" formControlName="course" [disabled]="!courseOptions.length">
            <option value="" disabled>{{ courseOptions.length ? 'Select course' : 'No streams or courses configured for your college' }}</option>
            <option *ngFor="let c of courseOptions" [value]="c">{{ c }}</option>
          </select>
          <small class="text-danger" *ngIf="form.get('course')?.touched && form.get('course')?.hasError('required')">
            Course / degree is required
          </small>
          <small class="field-hint" *ngIf="!courseOptions.length">
            Add streams or courses to your college profile to enable this field.
          </small>
        </div>

        <div class="field-item">
          <label class="field-lbl">City</label>
          <input type="text" class="standard-input" formControlName="city" placeholder="City" />
        </div>

        <div class="field-item">
          <label class="field-lbl">Year of Passing<span class="required-star">*</span></label>
          <input type="number" class="standard-input" formControlName="year_of_passing" placeholder="e.g. 2026" min="1950" max="2100" />
          <small class="text-danger" *ngIf="form.get('year_of_passing')?.touched && form.get('year_of_passing')?.hasError('required')">
            Year of passing is required
          </small>
          <small class="text-danger" *ngIf="form.get('year_of_passing')?.touched && (form.get('year_of_passing')?.hasError('min') || form.get('year_of_passing')?.hasError('max'))">
            Year of passing must be between 1950 and 2100
          </small>
        </div>
      </div>

      <label class="invite-checkbox-row">
        <input type="checkbox" formControlName="send_invite" />
        <span>Send account invitation to student's email once added</span>
      </label>

      <div class="modal-footer-row">
        <button type="button" class="btn-cancel" (click)="close.emit()" [disabled]="isSubmitting">Cancel</button>
        <button type="submit" class="btn-submit" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Adding…' : 'Add Student' }}
        </button>
      </div>
    </form>

    <!-- ============== UPLOAD CSV ============== -->
    <div *ngIf="activeTab === 'csv'" class="csv-tab">
      <div class="csv-columns-row">
        <span class="csv-columns-label">Expected columns:</span>
        <span class="csv-columns-list">
          <code *ngFor="let col of csvColumns; let last = last">{{ col }}<ng-container *ngIf="!last">, </ng-container></code>
        </span>
        <button type="button" class="btn-template" (click)="downloadTemplate()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Template
        </button>
      </div>

      <label class="csv-dropzone" *ngIf="!selectedFile">
        <input type="file" accept=".csv" (change)="onFileSelected($event)" hidden />
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
        <strong>Click to upload CSV</strong>
        <span>.csv file with the columns listed above</span>
      </label>

      <div class="csv-selected-file" *ngIf="selectedFile">
        <div class="csv-file-info">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
          <span>{{ selectedFile.name }}</span>
        </div>
        <button type="button" class="btn-remove-file" (click)="removeSelectedFile()" [disabled]="isUploading">Remove</button>
      </div>

      <div class="csv-invite-row" *ngIf="!bulkResult">
        <label class="invite-checkbox-row">
          <input type="checkbox" [formControl]="form.controls.send_invite" />
          <span>Send account invitation to each student's email once added</span>
        </label>
      </div>

      <!-- Results summary -->
      <div class="csv-results" *ngIf="bulkResult">
        <div class="csv-results-summary">
          <div class="csv-stat csv-stat--created">
            <strong>{{ bulkResult.created }}</strong>
            <span>Added</span>
          </div>
          <div class="csv-stat csv-stat--duplicate">
            <strong>{{ bulkResult.duplicate }}</strong>
            <span>Duplicate</span>
          </div>
          <div class="csv-stat csv-stat--invalid">
            <strong>{{ bulkResult.invalid }}</strong>
            <span>Invalid</span>
          </div>
        </div>

        <div class="csv-results-list" *ngIf="bulkResult.invalid > 0 || bulkResult.duplicate > 0">
          <div class="csv-result-row" *ngFor="let row of bulkResult.results" [class.is-error]="row.status !== 'created'">
            <span class="csv-result-row-num">Row {{ row.row_number }}</span>
            <span class="csv-result-email">{{ row.email || row.first_name || '—' }}</span>
            <span class="csv-result-status" [ngClass]="row.status">{{ row.status }}</span>
            <span class="csv-result-msg" *ngIf="row.status !== 'created'">{{ row.message }}</span>
          </div>
        </div>
      </div>

      <div class="modal-footer-row">
        <button type="button" class="btn-cancel" (click)="close.emit()" [disabled]="isUploading">
          {{ bulkResult ? 'Close' : 'Cancel' }}
        </button>
        <button
          type="button"
          class="btn-submit"
          *ngIf="!bulkResult"
          [disabled]="isUploading || !selectedFile"
          (click)="uploadCsv()">
          {{ isUploading ? 'Uploading…' : 'Upload & Add Students' }}
        </button>
      </div>
    </div>
  </div>
</div>
